import { Action } from "types/generated";

import { AccessSection, FormValues } from "./types";

export const CONFIG: AccessSection[] = [
  {
    title: "Runs",
    id: "run",
    permissions: [
      {
        action: Action.RunTrigger,
        id: "trigger",
        description: "Helper text",
      },
      {
        action: Action.RunTriggerWithCustomRuntimeConfig,
        id: "triggerWithCustomRuntimeConfig",
        description: "Helper text",
      },
      {
        action: Action.RunCancel,
        id: "cancel",
        description: "Helper text",
      },
      {
        action: Action.RunCancelBlocking,
        id: "cancelBlocking",
        description: "Helper text",
      },
      {
        action: Action.RunComment,
        id: "comment",
        description: "Helper text",
      },
      {
        action: Action.RunConfirm,
        id: "confirm",
        description: "Helper text",
      },
      {
        action: Action.RunDiscard,
        id: "discard",
        description: "Helper text",
      },
      {
        action: Action.RunPrioritizeSet,
        id: "prioritizeSet",
        description: "Helper text",
      },
      {
        action: Action.RunPromote,
        id: "promote",
        description: "Helper text",
      },
      {
        action: Action.RunProposeLocalWorkspace,
        id: "proposeLocalWorkspace",
        description: "Helper text",
      },
      {
        action: Action.RunProposeWithOverrides,
        id: "proposeWithOverrides",
        description: "Helper text",
      },
      {
        action: Action.RunStop,
        id: "stop",
        description: "Helper text",
      },
      {
        action: Action.RunStopBlocking,
        id: "stopBlocking",
        description: "Helper text",
      },
    ],
  },
  {
    id: "tasks",
    title: "Tasks",
    permissions: [
      {
        action: Action.TaskCreate,
        id: "taskCreate",
        description: "Helper text",
      },
    ],
  },
];

export const DEFAULT_VALUES: FormValues = {
  name: "",
  description: "",
  permissions: CONFIG.reduce((acc, next) => {
    return {
      ...acc,
      [next.id]: next.permissions.reduce((acc, next) => ({ ...acc, [next.action]: false }), {}),
    };
  }, {}),
};
